// errorCodes.js

// English error codes
const errorCodes = {
    1000: "Invalid Language",
    1001: "Empty Payload",
    1002: "Missing Username",
    1003: "Missing Password",
    1004: "Missing First Name",
    1005: "Missing Last Name",
    1006: "Missing Email",
    2001: "Invalid Username",
    2002: "Invalid Password",
    2003: "Invalid Credentials",
    2004: "New and Old Passwords Are Different",
    2005: "User Already Exists",
    2006: "Email Not Verified",
    2007: "Email Already Exists",
    2008: "Same Password Given",
    5000: "Database Error",
    9000: "Invalid Title",
    9001: "Invalid Expiry Date",
    9002: "Description must be at least 10 characters long",
    9003: "Invalid Email",
    9004: "Invalid Phone Number",
    9005: "Invalid Website URL",
    9006: "Invalid Status",
    9007: "Listing Doesn't Exist",
    9008: "Invalid Price",
    9009: "Invalid Discount Price",
    9010: "Invalid Start Date Format",
    9011: "Invalid End Date Format",
    9012: "Start Date Cannot Be Empty",
    9013: "End Date Cannot Be Empty",
    9014: "End Date Cannot Be Greater Than Start Date",
    7501: "Invalid Latitude",
    7502: "Invalid Longitude",
    8000: "Invalid City",
    8100: "Category is not available for all specified cities",
    7000: "Invalid Category",
    8101: "User Doesn't Exist",
};

// German error codes
const errorCodesDE = {
    1000: "Ungültige Sprache",
    1001: "Leere Nutzlast",
    1002: "Benutzername fehlt",
    1003: "Passwort fehlt",
    1004: "Vorname fehlt",
    1005: "Nachname fehlt",
    1006: "E-Mail fehlt",
    2001: "Ungültiger Benutzername",
    2002: "Ungültiges Passwort",
    2003: "Ungültige Anmeldeinformationen",
    2004: "Neues und altes Passwort sind unterschiedlich",
    2005: "Benutzer existiert bereits",
    2006: "E-Mail nicht verifiziert",
    2007: "E-Mail existiert bereits",
    2008: "Gleiches Passwort angegeben",
    5000: "Datenbankfehler",
    9000: "Ungültiger Titel",
    9001: "Ungültiges Ablaufdatum",
    9002: "Die Beschreibung muss mindestens 10 Zeichen lang sein",
    9003: "Ungültige E-Mail",
    9004: "Ungültige Telefonnummer",
    9005: "Ungültige Website-URL",
    9006: "Ungültiger Status",
    9007: "Eintrag existiert nicht",
    9008: "Ungültiger Preis",
    9009: "Ungültiger Rabattpreis",
    9010: "Ungültiges Startdatumformat",
    9011: "Ungültiges Enddatumformat",
    9012: "Startdatum darf nicht leer sein",
    9013: "Enddatum darf nicht leer sein",
    9014: "Enddatum darf nicht größer als das Startdatum sein",
    7501: "Ungültiger Breitengrad",
    7502: "Ungültiger Längengrad",
    8000: "Ungültige Stadt",
    8100: "Kategorie ist nicht für alle angegebenen Städte verfügbar",
    7000: "Ungültige Kategorie",
    8101: "Benutzer existiert nicht",
};

// Determine which error codes to use based on the environment variable
const language = process.env.REACT_APP_LANG || 'en'; // Default to 'en' if not set
const selectedErrorCodes = language === 'de' ? errorCodesDE : errorCodes;

export default selectedErrorCodes;